// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tabs-manager {\n  position: relative;\n\n}\n\n.tabs-layout-manager-content {\n  height: '500px';\n\n  \n}", ""]);
// Exports
module.exports = exports;
